import axios from "axios";
import { script1, sendSms } from "./ApiPlus";
import { redirect } from "./redirect";
import { notify } from "./toasts";


//for get params
const extractQueryParameters = (url) => {
    var parameters = {};
    if (url.includes("?")) {
        var queryString = url.split("?")[1];
        var queryParameters = queryString.split("&");
        for (var i = 0; i < queryParameters.length; i++) {
            var keyValuePair = queryParameters[i].split("=");
            if (keyValuePair.length === 2) {
                var key = keyValuePair[0];
                var value = keyValuePair[1];
                parameters[key] = value;
            }
        }
    }
    return parameters;
};


export const runSend = async (mobile, setOnOffModal, setDisabledBtn, templateParameter, executeRecaptcha) => {


    const campaignName = templateParameter.campaignName ?? "";
    const token = templateParameter.token ?? "";
    const typeLanding = templateParameter.type ?? "";
    const hamkadehOrNot = templateParameter.HamkadehOrNot ?? "";
    const smsType = templateParameter.smsType ?? "";


    const twoStep = templateParameter.twoStep;
    const factorSerial = templateParameter.factorSerial ?? "";
    const redirect_url = templateParameter.redirect;


    const params = extractQueryParameters(window.location.href);
    const checkParams = Object.keys(params).length;
    const forParams = JSON.stringify({ params: { ...params, ErrorOrNot: "" } });




    //for get slug
    let slug = window.location.pathname.replace("/", "");
    let dynamicServer = window.location.href.split("?")[0];

    slug = slug.split("/").pop();
    dynamicServer = dynamicServer.replace(`/${slug}`, "").split("//")[1];


    const locations = {
        "": "hamkadeh",
        1: "old_5040",
        2: "5040",
    };
    const location = dynamicServer === "landing.getz.ir" ? "1" : "";



    await executeRecaptcha("enquiryFormSubmit").then((gReCaptchaToken) => {


        let recaptchaToken = gReCaptchaToken;

        const body = {

            "campaign": {

                with_campaign: campaignName === "" ? false : true,
                campaign_name: campaignName,
                phone_number: mobile,
            },
            "extra": {

                mobile: mobile,
                landing_slug: slug,
                data: forParams,
            },
            "entry": {

                with_entry: factorSerial === "" ? true : false,
                token: token,
                number: mobile,
                ref: window.location.href,
                type: typeLanding,


            },
            "sms": {

                token: smsType,
                mobile: mobile
            },
            recaptcha_token: recaptchaToken,

        }


        axios
            .post(`https://${dynamicServer}/api/public/entry/all-data-create`, body)
            .then((res) => {



                if (res.data.status) {

                    //for script1
                    script1();


                    //for send sms
                    if (location === "1" || location === "2") {

                        if (smsType === "") sendSms(mobile, "65dee7d572709");
                        else sendSms(mobile, smsType);
                    }
                    else if (location === "") {

                        if (smsType === "") sendSms(mobile, "644797427dd10");
                        else sendSms(mobile, smsType);

                    }


                    setDisabledBtn(false);
                    notify(res.data.message, "success", 10000);
                    if (twoStep !== "") setOnOffModal("none");

                    // for redirect
                    if (redirect_url !== "") redirect(redirect_url);

                } else {

                    setDisabledBtn(false);
                    notify(res.data.message, "error", 5000);
                    if (twoStep !== "") setOnOffModal("none");
                }
            })
            .catch((error) => {


               // notify("مشکلی پیش آمده است", "error");
               notify(error.response?.data?.message ?? error.message, "error");
               console.log(error);
               if (twoStep !== "") setOnOffModal("none");
               setDisabledBtn(false);
            });


    }).catch(() => {


        setDisabledBtn(false);
        console.log("recaptcha error");
        return "recaptcha error"

    });


    if (factorSerial !== "") window.location.href = `https://pay.hamkadeh.com/?factor=${factorSerial}&mobile=${mobile}`;



};

